import register from '../../../../global/js/registry';
export default register('o-teaser-single-row-staggered', () => import(/* webpackMode: "lazy" */ './o-teaser-single-row-staggered.controller'));
